"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderWorkingShift_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var ProviderWorkingShift_Factory = /** @class */ (function () {
    function ProviderWorkingShift_Factory() {
    }
    ProviderWorkingShift_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DayOfWeek: model.DayOfWeek,
            Description: model.Description,
            DurationInMinutes: model.DurationInMinutes,
            EndTime: Date_Factory_1.Date_Factory.CreateIncoming(model.EndTime),
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            Name: model.Name,
            ProviderWorkingTemplateId: model.ProviderWorkingTemplateId,
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateIncoming(model.StartTime),
        };
        return result;
    };
    ProviderWorkingShift_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DayOfWeek: model.DayOfWeek,
            Description: model.Description,
            DurationInMinutes: model.DurationInMinutes,
            EndTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.EndTime),
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            Name: model.Name,
            ProviderWorkingTemplateId: model.ProviderWorkingTemplateId,
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartTime),
        };
        return result;
    };
    return ProviderWorkingShift_Factory;
}());
exports.ProviderWorkingShift_Factory = ProviderWorkingShift_Factory;
